export const CreatorDefaultValue = [
  {
    id: 1,
    name: null,
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/1.png",
    balance: 300,
  },
  {
    id: 2,
    name: "Oxygen",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/2.png",
    balance: 1300,
  },
  {
    id: 3,
    name: "Cinematic",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/3.png",
    balance: 300,
  },
  {
    id: 4,
    name: "Superstar",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/4.png",
    balance: 650,
  },
  {
    id: 5,
    name: "Doctor_Mundi",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/5.png",
    balance: 876,
  },
  {
    id: 6,
    name: "CyberMan",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/6.png",
    balance: 110,
  },
  {
    id: 7,
    name: "UserName",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/7.png",
    balance: 356,
  },
  {
    id: 8,
    name: "Girl99",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/8.png",
    balance: 789,
  },
  {
    id: 9,
    name: "Gray_Artist",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/9.png",
    balance: 40,
  },
  {
    id: 10,
    name: "Shlok",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/10.png",
    balance: 56,
  },
  {
    id: 11,
    name: "Anonymous",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/12.png",
    balance: 1110,
  },
  {
    id: 12,
    name: "Avalanche",
    wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    ava: "../../../assets/img/default/ava/13.png",
    balance: 900,
  },
];
